<template>
  <div>
    <div class="dropdown">
      <div class="label-title" v-if="label">{{label}}</div>
      <div class="input" @click="show=true" :class="{'active':show,'error':error&&!show}">
        <div class="text-container padding-left">
          <div class="display-text">{{displayText}}</div>
          <div v-show="!displayText&&description" class="desc">{{description}}</div>
          <input v-bind="$attrs" type="text" :value="value" />
        </div>
        <img v-if="rightIcon" class="right-icon" :src="rightIcon" alt />
      </div>
    </div>
    <modal
      :size="20"
      v-show="show"
      :padding="false"
      v-on="$listeners"
      @escape="hideModal"
      @complete="hideModal"
      @click-mask="hideModal"
    >
      <div slot="body">
        <datepicker @change="changeValue" :min="min" :max="max" :current="value" />
      </div>
    </modal>
  </div>
</template>
<script>
import moment from "moment";
import validatable from "../validatable"
import images from "../../../core/images";
import Modal from "@/components/layout/Modal";
export default {
  inheritAttrs: false,
  mixins: [validatable],
  name: "ttw-datepicker",
  components: {
    Modal: Modal
  },
  props: {
    min: String,
    max: String,
    label: String,
    value: { default: null },
    description: {
      type: String,
      default: "Select"
    }
  },
  data() {
    return {
      show: false
    };
  },
  computed: {
    rightIcon: () => images.triangle,
    displayText() {
      if (this.value) {
        return moment(this.value).format("YYYY MMM DD");
      }
      return "";
    }
  },
  methods: {
    hideModal() {
      this.show = false;
    },
    changeValue(val) {
      this.$emit("input", moment(val).format("YYYY-MM-DD"));
      return this.hideModal();
    }
  }
};
</script>